module.exports = __webpack_public_path__ + "static/media/Hyaluron_Collagen_komplex_gel_retina.353b749f.jpg";